import { useEffect } from 'react';
import { cleanupAllStores } from '@/utils/localStorage-cleanup';

export function useStoreCleanup() {
  useEffect(() => {
    cleanupAllStores();
  }, []);
}
